import React, {  useContext } from 'react';
import { NodeDisplayContext } from './Contexts';
import PositionedItem from './PositionedItem';
import NodePositioner from './NodePositioner';



 
function expandBase(location){
  return {
    alignItems:({t:"start",m:"center",b:"flex-end"})[location[0]],
    justifyContent:({l:"start",m:"center",r:"flex-end"})[location[1]],
  }
}

const DRAGGABLE = false;





function TemplateNodePositionedItem({
  selectedNodes,
  onEvent,
  evaluate,
  nodeId,
  node,
  parentBox, 
  nodes, 
  regions
}){
  
  //let expansionTemplateInfo = useContext(ExpansionTemplateInfo);

  let nodeDisplayContext = useContext(NodeDisplayContext);


  //let { thumbnail } = expansionTemplateInfo || {};

  //if( thumbnail ){ debugger; }

  let { 
    type, label, 
    location, 
    style={}, 
    setItem, 
  } = node;
  
  let { margin, 
    borderWidth,
    borderStyle,
    borderColor,
    border,
    padding,
    outline,
    ...otherStyle } = style;

 
  let positionedItem = <PositionedItem {...{
    type, style:otherStyle, nodeId, node, nodes, regions,
  
    onEvent, 
    //onItemClick,
  //thumbnail,
  label,
  evaluate,
  parentBox,
    }}/>


    let mouseFocusControllerId = nodeId



  let nodeDisplayOverride = nodeDisplayContext?.nodeDisplay?.({node,nodeId,
    called:"TemplateNodePositionedItem",
  })
  /*if( nodeDisplayOverride !== undefined ){
    content = nodeDisplayOverride;
  }
  */

  let decoration = nodeDisplayContext?.nodeDecoration?.({
    nodeId,node,
    caller:"TemplateNodePositionedItem",
  })


  return (
    <>

      <NodePositioner style={style} nodeId={nodeId} position={location} node={node} parentBox={parentBox} interactive={!decoration}>
          {positionedItem}
        {decoration}
        {false && <div onClick={e => {
          e.stopPropagation(); }} onMouseDown={e => e.stopPropagation()} class="absolute-cover bg-blue"/>}
      </NodePositioner>

      

      
    </>
  )

}

export default React.memo(TemplateNodePositionedItem);





